import React from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setElementsScoreSettings, useElementsScoreSettings } from 'reducers/reviewCreationSlice';

import { ScoreSettingTable } from 'uiToolkitV1/ScoreSettingTable';

const ScoreSettings = ({ feedbackFormId }) => {
  const dispatch = useDispatch();
  let { autoComputeGoalRatingSettings, isGoalSectionEditable, isGoalRatingAutoComputed } = useElementsScoreSettings({
    feedbackFormId,
  });
  autoComputeGoalRatingSettings = autoComputeGoalRatingSettings ?? [];

  if (!isGoalRatingAutoComputed) {
    return null;
  }

  const onChangeHandler = (newVal) => {
    dispatch(
      setElementsScoreSettings({
        feedbackFormId,
        settings: { autoComputeGoalRatingSettings: newVal },
      })
    );
  };
  const handleSetIsGoalSectionEditable = (newVal) => {
    dispatch(
      setElementsScoreSettings({
        feedbackFormId,
        settings: { isGoalSectionEditable: newVal },
      })
    );
  };

  return (
    <Box px={2} mt={3}>
      <ScoreSettingTable
        scoreSetting={autoComputeGoalRatingSettings}
        onChange={onChangeHandler}
        isGoalSectionEditable={isGoalSectionEditable}
        setIsGoalSectionEditable={handleSetIsGoalSectionEditable}
        feedbackFormId={feedbackFormId}
      />
    </Box>
  );
};

export { ScoreSettings };
